import Swiper from "swiper";
import { Pagination, EffectFade } from "swiper/modules";
import "swiper/swiper-bundle.css";

window.addEventListener('load', () => {
  new Swiper('.two-columns-content-item__slider', {
    modules: [Pagination, EffectFade],
    loop: false,
    speed: 500,
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
});
